import React from "react";
import {HashLink as Link} from 'react-router-hash-link';
import Panel from "../../Panel";
import {publicBuildUrl} from "../../../config/config";
import Modal from "../../Modal";

const SnavelDilemmas = () => (
    <Modal>
        <div>
            <Panel
                title={'Welke dilemma’s kunnen jou als professional ervan weerhouden om je zorgen bespreekbaar te maken?'}
                link={'Lees meer'}
                open={true}
                intro={'In gesprekken met kinderen over kindermishandeling heeft iedere professional zijn\n' +
                    '            eigen taak. Een jeugdhulpverlener heeft andere verantwoordelijkheden dan een\n' +
                    '            leerkracht en Veilig Thuis een andere taak dan de politie. Toch komen deze en alle\n' +
                    '            andere professionals veelal dezelfde twijfels en dilemma’s tegen ten aanzien van het\n' +
                    '            praten met kinderen over hun thuissituatie. Wanneer je in je eentje blijft rondlopen\n' +
                    '            met deze twijfels, kom je als professional steeds meer in je hoofd terecht. Dat gaat\n' +
                    '            ten koste van het contact met het kind. Het kan gebeuren dat professionals een\n' +
                    '            gesprek met het kind daardoor maar voor zich uit blijven schuiven of tijdens een\n' +
                    '            gesprek aan de oppervlakte blijven, waardoor kinderen zich onvoldoende gezien en\n' +
                    '            gehoord voelen. In elke fase van een traject van signaleren tot en met het maken van\n' +
                    '            veiligheidsafspraken en hulp kun je obstakels tegenkomen, die je er steeds opnieuw\n' +
                    '            van kunnen weerhouden om (nog eens) met het kind in gesprek te gaan. Het\n' +
                    '            dilemmacirkel legt uit hoe dit er uit kan zien en hoe je dit kunt oplossen.'}>

                <p className={'text'}>
                    In gesprekken met kinderen over kindermishandeling heeft iedere professional zijn
                    eigen taak. Een jeugdhulpverlener heeft andere verantwoordelijkheden dan een
                    leerkracht en Veilig Thuis een andere taak dan de politie. Toch komen deze en alle
                    andere professionals veelal dezelfde twijfels en dilemma’s tegen ten aanzien van het
                    praten met kinderen over hun thuissituatie. Wanneer je in je eentje blijft rondlopen
                    met deze twijfels, kom je als professional steeds meer in je hoofd terecht. Dat gaat
                    ten koste van het contact met het kind. Het kan gebeuren dat professionals een
                    gesprek met het kind daardoor maar voor zich uit blijven schuiven of tijdens een
                    gesprek aan de oppervlakte blijven, waardoor kinderen zich onvoldoende gezien en
                    gehoord voelen. In elke fase van een traject van signaleren tot en met het maken van
                    veiligheidsafspraken en hulp kun je obstakels tegenkomen, die je er steeds opnieuw
                    van kunnen weerhouden om (nog eens) met het kind in gesprek te gaan. Het
                    dilemmacirkel legt uit hoe dit er uit kan zien en hoe je dit kunt oplossen.
                </p>

                <img src={publicBuildUrl + 'images/circle.png'} alt={''}
                     style={{border: '1px solid #003d4c', width: '625px', marginBottom: '20px'}}/>

                <h3>1. Ik maak me zorgen:</h3>
                <p className={'text'}>
                    Wanneer je signalen oppikt die kunnen duiden op kindermishandeling doet dat iets
                    met je. Je maakt je zorgen om het kind en wilt dat de situatie beter wordt. Als je
                    vermoedt dat er sprake is van een onveilige situatie, maar je dit (nog) niet kunt
                    onderbouwen, kan het echter lastig zijn om de stap te nemen om met het kind in
                    gesprek te gaan. Je wilt het kind niet onnodig belasten en eigenlijk heb je nog weinig
                    concreet waar je zorgen op gebaseerd zijn. Hoe langer je vastzit in de dilemmacirkel,
                    hoe meer je zorgen soms toenemen. Maar het kan ook gebeuren dat je jezelf
                    probeert te ‘sussen’: misschien valt het wel mee. Deze vermijdende strategie kan
                    ervoor zorgen dat je een gesprek uit de weg gaat.
                </p>

                <h3>2. Twijfels</h3>
                <p className={'text'}>
                    Zodra je je zorgen maakt, komen doorgaans ook de eerste twijfels: zie ik het wel
                    goed? Je bent je ervan bewust dat jouw blik gekleurd kan zijn door de indruk die je
                    hebt van de ouders of de situatie, terwijl je daarover nog te weinig weet. Als
                    professional wil je geen overhaaste en ongefundeerde conclusies trekken en al
                    helemaal niemand vals beschuldigen. Sommige professionals vragen zich af of zij
                    wel degene zijn die met het kind in gesprek zouden moeten. Kunnen anderen dat
                    niet veel beter? Deze en andere twijfels kunnen je onzeker maken, waardoor je een
                    gesprek met het kind nog even uitstelt.
                </p>

                <h3>3. Nog even aankijken</h3>
                <p className={'text'}>
                    Als je nog onvoldoende weet om de situatie goed in te kunnen schatten, vraag je je
                    misschien af of dit al het juiste moment is om met het kind in gesprek te gaan.
                    Voordat je stappen onderneemt, wil je eerst zekerder zijn van je zaak. Je kijkt het
                    daarom nog even aan. Dat ‘even aankijken’ kan, wanneer je niet gericht en gepland
                    gaat observeren, ongemerkt erg lang duren.
                </p>

                <h3>4. Op zoek naar ‘bewijs’</h3>
                <p className={'text'}>
                    Omdat je je niet-pluisgevoel wilt kunnen onderbouwen voordat je het bespreekbaar
                    maakt, word je (over?)alert op signalen. Je gaat dan vaak – deels bewust, deels
                    onbewust – op zoek naar bevestiging voor wat je al vermoedt. Dat kan ervoor zorgen
                    dat je op een suggestieve manier in gesprek gaat met je collega of de ouders of dat
                    je zaken al te snel interpreteert. Op zoek gaan naar ‘bewijs’ is (behalve wanneer je bij
                    justitie werkt) niet de taak van professionals.
                </p>

                <h3>5. Angst voor de gevolgen</h3>
                <p className={'text'}>
                    Als je gaat speuren naar ‘bewijs’ vind je vaak ook echt meer signalen. Hoe meer jouw
                    vermoeden bevestigd wordt, hoe meer je je realiseert dat je in actie moet komen. Bij
                    veel professionals komt op dat moment angst op voor de eventuele gevolgen die dat
                    kan hebben. Wat zou er gebeuren als je het kind zou vragen naar de thuissituatie?
                    Beschadig je het kind dan niet nog meer, doordat hij met jou ‘moet’ praten over wat
                    er aan de hand is? Wat als de ouders erachter komen? Betaalt het kind daarvan
                    straks de rekening? En wat als de ouders verhaal komen halen bij jou? Je angst voor
                    de gevolgen van zo’n gesprek kunnen maken dat je er bewust of onbewust voor kiest
                    om het gesprek nog even uit te stellen.
                </p>

                <h3>6. Uit contact</h3>
                <p className={'text'}>
                    Wanneer je zo bezig bent met het verzamelen van ‘bewijs’ en met je angst voor de
                    eventuele gevolgen van een gesprek met een kind, ben je (vaak onbewust en
                    ongewild) steeds meer met jezelf bezig. Daardoor ben je minder alert op het
                    onderhouden van de vertrouwensrelatie met het kind. Je gaat ongemerkt en
                    onbedoeld steeds meer uit contact. Kinderen merken wanneer ze geen (echt) contact
                    met je hebben.
                </p>

                <h3>7. Schaamte en schuldgevoel</h3>
                <p className={'text'}>
                    Intussen kan het flink gaan ‘knagen’: je voelt je verantwoordelijk om hier iets mee te
                    doen en je voelt je schuldig dat je dat nog steeds niet hebt gedaan. Je schaamt je dat
                    jij als professional er niet in slaagt om er werkelijk voor het kind te zijn. Je blijft je
                    zorgen maken, want intussen speelt dit al best lang en heb je nog steeds de stap niet
                    gezet om je zorgen bespreekbaar te maken.
                </p>
                <p className={'text'}>
                    Zonder dat je het in de gaten hebt, kunnen je afweermechanismes (je wilt niet dat dit
                    waar is, je kunt niet instaan voor de gevolgen, je bent er niet voor opgeleid om deze
                    gesprekken te voeren) ervoor zorgen dat je blijft hangen in deze of een vergelijkbare
                    vicieuze cirkel. De dilemmacirkel heeft niet per se een vaste volgorde of een vast
                    start- of eindpunt. Je kunt er op elk moment uitstappen, mits je herkent dat je erin
                    vastzit. Helpend daarbij is het delen van dilemma’s met collega’s. In overleg,
                    coaching of intervisie kun je samen bekijken waar je precies in vastloopt en wat je
                    nodig hebt om uit de dilemmacirkel te stappen.
                </p>

                <p className={'quote-source'}>
                    <strong>Bron</strong>: van Gemert, N. (2019). Praktijkboek praten met kinderen over
                    kindermishandeling. Bohn Stafleu van Loghum.
                </p>
            </Panel>


        </div>
    </Modal>
);


export default SnavelDilemmas;
